import { waitForElementById } from './helpers';

/**
 * Scrolls to an element with smooth behavior
 * @param elementId - The ID of the element to scroll to
 * @param offset - Optional offset from the top (useful for fixed headers)
 */
export function scrollToElement(elementId: string, offset: number = 100) {
  const element = document.getElementById(elementId);
  if (element) {
    const elementRect = element.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset;
    const finalScrollPosition = absoluteElementTop - offset;

    window.scrollTo({
      top: finalScrollPosition,
      behavior: 'smooth',
    });
  } else {
    console.warn(`[scrollToAnchor] Element not found: ${elementId}`);
  }
}

/**
 * Handles hash navigation by waiting for the element to exist and then scrolling to it
 * @param hash - The hash fragment (with or without #)
 * @param offset - Optional offset from the top
 */
export function handleHashNavigation(hash: string, offset: number = 100) {
  const elementId = hash.replace('#', '');

  if (elementId) {
    waitForElementById(elementId, () => {
      scrollToElement(elementId, offset);
    });
  }
}

export function handleInitialHashScroll(offset: number = 100) {
  if (typeof window === 'undefined') {
    return;
  }

  const hash = window.location.hash;
  if (hash) {
    handleHashNavigation(hash, offset);
  }
}
